export default __webpack_public_path__ + "static/media/small-blue-green-pattern.d711365d.svg";